import {create, get, stripPositionStyles, isNumber, isValidDateString, toMMddyyyy, clone, 
        formatDate, toValidDateString, scrollOffset, getDocumentHeight, dateFormat,
        monthNames, dayAbbr, todayString, isWeekend, getWindowHeight, getWindowWidth,
        removeCSS
} from "./ccbh";

var pathToCSSFolder = '/Content/';
var pathToImagesFolder = '/Content/img/';
var alertNotFound = false; //alert when target elements are not found (debug)

//create link to ccbh.ui.css file
//var fileref = create('link');
//fileref.setAttribute('rel', 'stylesheet');
//fileref.setAttribute('type', 'text/css');
//fileref.setAttribute('href', pathToCSSFolder + 'ccbh.ui.css');
//if (typeof fileref != 'undefined'){
//    document.getElementsByTagName("head")[0].appendChild(fileref);
//}
//initiate datepicker option on input text field
export function ccbhdatepicker(parameters) {
    var field, maxDate, minDate;
    field = loadParameter(parameters.target);
    maxDate = loadParameter(parameters.maxdate);
    minDate = loadParameter(parameters.mindate);
    var direction = loadParameter(parameters.direction);

    //get field, make sure wasn't passed by name
    var inputField = field;
    if (inputField.id == undefined) {
        inputField = get(field);
        if (inputField == undefined) {
            if (alertNotFound) {
                alert('Input field ' + field + ' could not be found');
            }
            return;
        }
    }

    //if the element is already wrapped with div, remove it
    if (inputField.parentNode.id == inputField.id + '_wrapper') {
        var wrapper = inputField.parentNode;
        var parent = wrapper.parentNode;
        //var input = wrapper.childNodes[0];
        parent.appendChild(inputField);
        parent.removeChild(wrapper);
    }

    //wrap with div
    var wrapper = create('div');
    wrapper.id = inputField.id + '_wrapper';
    //get all css applied to input field
    var styles = getComputedStyle(inputField);
    if (styles) {
        //add positioning styles to wrapper
        wrapper.style.display = styles.display;
        wrapper.style.position = styles.position;
        wrapper.style.top = styles.top;
        wrapper.style.left = styles.left;
    }
    wrapper.style.width = '140px';
    //strip positioning styles from input field
    stripPositionStyles(inputField);
    wrap(wrapper, inputField);
    //draw icon with onclick event
    var icon = create('img');
    icon.id = inputField.id + '_img';
    icon.src = pathToImagesFolder + 'ccbhdatepicker.gif';
    icon.className = 'ccbhdatepicker_icon';
    //check for maxdate and min date params, convert to date strings
    var params = [];
    if (maxDate != undefined) {
        if (isNumber(maxDate)) {
            maxDate = toMMddyyyy(addDays(maxDate));
        }
        if (isValidDateString(maxDate)) {
            params.push('maxdate', maxDate);
        }
    }
    if (minDate != undefined) {
        if (isNumber(minDate)) {
            minDate = toMMddyyyy(addDays(minDate));
        }
        if (isValidDateString(minDate)) {
            params.push('mindate', minDate);
        }
    }
    icon.onclick = function () { showCal(this, clone(params)); };
    //append to end of inputField inside div
    wrapper.appendChild(icon);
    //add event listener for keydown
    //addEventHandler(inputField, 'keydown', function () { formatThisDate(); });
    if (!inputField.onkeyup) {
        addEventHandler(inputField, 'keyup', function () { dateFormat(this); });
    }
    inputField.maxLength = 10;
    //add click listener to see when user leaves calendar
    if (document.addEventListener) {
        document.addEventListener('click', checkRealClick, false);
    } else if (document.attachEvent) {
        document.attachEvent('onclick', checkIEClick);
    }
}

//events for non-ie8 browsers
function checkRealClick(e) {
    if (e.target.className.indexOf('ccbhdatepicker') == -1) {
        removeCal();
    }
}
//event for ie8 and below
function checkIEClick(evt) {
    if (evt.srcElement.className.indexOf('ccbhdatepicker') == -1) {
        removeCal();
    }
}
function loadParameter(parameterelement, parameterload) {
    if (parameterelement != undefined) {
        return parameterelement;
    }
    return undefined;
}
//add n number of days to today, returns date format
function addDays(number) {
    var date = new Date();
    date.setDate(date.getDate() + number);
    return date;
}
//wrap div around field
function wrap(wrapper, field) {
    field.parentNode.insertBefore(wrapper, field);
    wrapper.appendChild(field);
}
//calls formatDate on current input field
function formatThisDate() {
    formatDate(document.activeElement);
}
//adds event handler to ie8 and current gen browsers
function addEventHandler(elem, eventType, handler) {
    if (elem.addEventListener)
        elem.addEventListener(eventType, handler, false);
    else if (elem.attachEvent)
        elem.attachEvent('on' + eventType, handler);
}
//called when image is clicked, if the calendar is not displayed, it shows it, otherwise it is hidden
function showCal(field, params) {
    var target = get(field.id.replace("_img", ""));

    if (target.getAttribute('readonly') != 'readonly') {
        if (field.getAttribute("displayed") != "true") {
            if (get("ccbhdatepicker-div") != undefined) {
                removeCal();
            }
            field.setAttribute("displayed", "true");
            //check for value of input field first
            var target = get(field.id.replace("_img", ""));
            var rect = target.getBoundingClientRect();
            generateCalendarHTML(target, rect.top + target.clientHeight, rect.left, target.value, params);
        } else {
            removeCal();
        }
        get(field.id.replace("_img", "")).focus();
    }
}
//creates floating div below target input box
function generateCalendarHTML(target, top, left, value, params) {
    var selected;
    var disable = [];
    //if what is currently in the box is a valid number, lets highlight it on the calendar
    if (isValidDateString(value)) {
        selected = clone(value);
    }
    value = toValidDateString(value);
    const valueDate = new Date(value);
    //draw div box
    var div = create('div');
    div.id = 'ccbhdatepicker-div';
    div.setAttribute('value', value);
    //store selected value, target field, and maxdate/mindate (params) in our dynamic div
    if (selected != undefined) {
        div.setAttribute('selected', toMMddyyyy(selected));
    }
    div.setAttribute('target', target.id);
    div.setAttribute('params', toNiceString(clone(params)));
    div.className = 'ccbhdatepicker-div';
    //if the item is going to be drawn off the bottom of the screen, move the div to the top of the field
    if (top + scrollOffset('top') + 185 > getDocumentHeight()) {
        div.style.top = (top + scrollOffset('top') - 185 - target.clientHeight) + 'px';
    } else {
        div.style.top = top + scrollOffset('top') + 'px';
    }
    div.style.left = left + scrollOffset('left') + 'px';
    //draw div wrapper for replacement on prev/next
    var month = create('div');
    month.id = 'ccbhdatepicker-wrapper';
    //draw navigation and calendar table
    month.appendChild(generateMonthAndDays(valueDate, selected, params, disable));
    div.appendChild(month);
    document.body.appendChild(div);
    //if at max and/or min dates, disable next and/or previous
    disableIcons(disable);
}

function generateMonthAndDays(valueDate, selected, params, disable) {
    //process params
    var maxDate;
    var minDate;
    //if params were not passed to it from the click event, check the div
    if (params == undefined) { params = checkParams(); }
    while (params.length > 0) {
        var peek = params.shift();
        if (peek == 'maxdate') {
            maxDate = new Date(params.shift());
        } else if (peek == 'mindate') {
            minDate = new Date(params.shift());
        }
    }
    //draw control and month header
    var body = create('div');
    body.id = 'ccbhdatepicker-body';
    var table = create('table');
    table.className = 'ccbhdatepicker-table';
    var tr = table.insertRow();
    tr.className = 'ccbhdatepicker-headerrow';
    var td = tr.insertCell();
    td.id = 'ccbhdatepicker-prev';
    td.className = 'ccbhdatepicker-prev ccbhdatepicker-hand ccbhdatepicker-clickable';
    td.onclick = function () { prevmonth(); };
    td.innerText = "<";
    var td = tr.insertCell();
    td.colSpan = 5;
    td.className = 'ccbhdatepicker-month';
    td.innerText = monthNames[valueDate.getMonth()] + ' ' + valueDate.getFullYear();
    var td = tr.insertCell();
    td.id = 'ccbhdatepicker-next';
    td.className = 'ccbhdatepicker-next ccbhdatepicker-hand';
    td.onclick = function () { nextmonth(); };
    td.innerText = ">";
    table.id = 'ccbhdatepicker-bodytable';
    table.style.width = '100%';
    //draw dow header row
    var tr = table.insertRow();
    var dateLoop = getSundayDate();
    for (var i = 0; i < 7; i++) {
        var th = tr.insertCell();
        th.className = 'ccbhdatepicker-' + dowcss(dateLoop) + '-header' + ' ccbhdatepicker-dowheader';
        th.innerText = dayAbbr[dateLoop.getDay()];
        dateLoop.setDate(dateLoop.getDate() + 1);
    }
    //draw days of month
    dateLoop = getFirstOfMonth(new Date(valueDate));
    var rowIndex = 0;
    var currentDOW = 0;
    var startingSpaces = false;
    var tr = table.insertRow();
    tr.className = 'ccbhdatepicker-dayrow';
    while (dateLoop.getMonth() == valueDate.getMonth()) {
        if (!startingSpaces) {
            //if the month does not start on a sunday, print some spaces
            while (currentDOW != dateLoop.getDay()) {
                generateSpace(tr);
                currentDOW += 1;
            }
            startingSpaces = true;
        }
        generateCell(tr, dateLoop, selected, maxDate, minDate, disable);
        if (dateLoop.getDay() == 6) {
            tr = table.insertRow();
            tr.className = 'ccbhdatepicker-dayrow';
        }
        dateLoop.setDate(dateLoop.getDate() + 1);
    }
    if (tr.childNodes.length == 0) {
        tr.className = 'ccbhdatepicker-emptyrow';
    }
    body.appendChild(table);
    return body;
}
//event fired when previous month button is clicked
function prevmonth() {
    changeMonth(false);
}
//event fired when next month button is clicked
function nextmonth() {
    changeMonth(true);
}
//changes month forward or backward
function changeMonth(forward) {
    var disable = [];
    var increment;
    var params;
    if (forward) {
        increment = 1;
    } else {
        increment = -1;
    }
    //get value as our index of the current month displayed
    var value = get("ccbhdatepicker-div").getAttribute("value");
    var valueDate = new Date(value);
    var month = valueDate.getMonth();
    var selected = getSelectedValue();
    while (valueDate.getMonth() == month) {
        valueDate.setDate(valueDate.getDate() + increment);
    }
    //set that value back into the outer div
    get("ccbhdatepicker-div").setAttribute("value", toMMddyyyy(valueDate));
    //replace everything inside the wrapper div
    var wrapper = get("ccbhdatepicker-wrapper");
    while (wrapper.firstChild) {
        wrapper.removeChild(wrapper.firstChild);
    }
    wrapper.appendChild(generateMonthAndDays(valueDate, selected, params, disable));
    disableIcons(disable);
}
function disableIcons(disable) {
    while (disable.length > 0) {
        var icon = get(disable.pop());
        icon.onclick = '';
        icon.className = icon.className.replace('ccbhdatepicker-hand', '');
        icon.className = icon.className.replace('ccbhdatepicker-clickable', '');
        icon.className += ' ccbhdatepicker-unselectable';
    }
}
//check the target input field to see if a value is currently in the field
function getSelectedValue() {
    var value = getTarget().value;
    if (isValidDateString(value)) {
        return new Date(value);
    } else {
        return undefined;
    }
}
//check the outerdiv to see if params are stored there
function checkParams() {
    var value = get("ccbhdatepicker-div").getAttribute("params");
    if (value != undefined && value != '') {
        return value.split(',');
    } else {
        return [];
    }
}
//ie8 fix - convert [] to comma separated string
function toNiceString(params) {
    var returnString = '';
    while (params.length > 0) {
        returnString += params.shift();
        if (params.length > 0) {
            returnString += ',';
        }
    }
    return returnString;
}
//creates empty cell for calendar spacing
function generateSpace(tablerow) {
    var td = tablerow.insertCell();
    td.className = 'ccbhdatepicker-unselectable';
}
//creates numeric cell for selecting
function generateCell(tablerow, date, selected, maxDate, minDate, disable) {
    var td = tablerow.insertCell();
    //add css classes for center, and weekday vs weekend
    td.className = 'ccbhdatepicker-center ccbhdatepicker-' + dowcss(date);
    //if a selected value is present and is the current day being drawn, add css
    if (selected != undefined) {
        var selectedDate = new Date(selected);
        if (selectedDate.getTime() == date.getTime()) {
            td.className += ' ccbhdatepicker-selected';
        }
    }
    //if min date and max date are present and the date is outside that range, add unselectable css
    if (minDate != undefined) {
        if (date.getTime() < minDate.getTime()) {
            td.className += ' ccbhdatepicker-unselectable';
        }
        if (date.getTime() <= minDate.getTime()) {
            disable.push('ccbhdatepicker-prev');
        }
    }
    if (maxDate != undefined) {
        if (date.getTime() > maxDate.getTime()) {
            td.className += ' ccbhdatepicker-unselectable';
        }
        if (date.getTime() >= maxDate.getTime()) {
            disable.push('ccbhdatepicker-next');
        }
    }
    var today = new Date(todayString());
    if (date.getTime() == today.getTime()) {
        td.className += ' ccbhdatepicker-today';
    }
    //if the unselectable css is not added, add the selectDay event to this cell
    if (td.className.indexOf('ccbhdatepicker-unselectable') == -1) {
        td.className += ' ccbhdatepicker-hand ccbhdatepicker-selectable';
        td.onclick = function () { selectDay(this); };
    }
    //set the data attributes for the cell for parsing the date when selectDay is fired
    td.setAttribute('data-day', date.getDate());
    td.setAttribute('data-month', date.getMonth() + 1);
    td.setAttribute('data-year', date.getFullYear());
    //draw the day of the month inside the cell
    td.innerText = date.getDate();
}
//event fired when a day of the month is selected
function selectDay(item) {
    //get pieces of date from attributes of cell
    var day = item.getAttribute("data-day");
    var month = item.getAttribute("data-month");
    var year = item.getAttribute("data-year");
    //find target currently displayed div
    var target = getTarget();
    //set value and remove calendar from html
    target.value = toMMddyyyy(new Date(month + '/' + day + '/' + year));
    //if the target has an onchange event, fire it
    if (target.onchange) {
        target.onchange();
    }
    removeCal();
}
//get first of the month for the date given
function getFirstOfMonth(date) {
    while (date.getDate() != 1) {
        date.setDate(date.getDate() - 1);
    }
    return date;
}
//return weekend or weekday based on date (for css)
function dowcss(date) {
    if (isWeekend(date)) {
        return "weekend";
    } else {
        return "weekday";
    }
}
//get previous sunday (for calendar header row)
function getSundayDate() {
    var date = new Date();
    while (date.getDay() != 0) {
        date.setDate(date.getDate() - 1);
    }
    return date;
}
//get target of currently displayed div
function getTarget() {
    var div = get("ccbhdatepicker-div");
    if (div != undefined) {
        return get(div.getAttribute("target"));
    } else {
        return undefined;
    }
}
//remove calendar, checks to see if dtp currently exists and removes html
function removeCal() {
    if (exists('ccbhdatepicker-div')) {
        var target = getTarget();
        var field = get(target.id + "_img");
        field.removeAttribute("displayed");
        var picker = get("ccbhdatepicker-div");
        picker.parentNode.removeChild(picker);
    }
}

/************ MESSAGE BOX ************/
export function ccbhmessagebox(parameters) {
    var message, displaydiv, title, closebutton, clicktoclose, buttons, modal, height, width, toggle;
    title = loadParameter(parameters.title);
    message = loadParameter(parameters.message);
    displaydiv = loadParameter(parameters.displaydiv);
    closebutton = loadParameter(parameters.closebutton);
    clicktoclose = loadParameter(parameters.clicktoclose);
    buttons = loadParameter(parameters.buttons);
    modal = loadParameter(parameters.modal);
    height = loadParameter(parameters.height);
    width = loadParameter(parameters.width);
    toggle = loadParameter(parameters.toggle);
    const overlay = loadParameter(parameters.overlay);
    const notitlediv = loadParameter(parameters.notitlediv);
    const addmessageboxclass = loadParameter(parameters.addmessageboxclass);
    const recursive = loadParameter(parameters.recursive);

    if (buttons == undefined && closebutton == undefined) {
        closebutton = true;
    }
    if (toggle != undefined && (toggle == true || toggle == 'true')) {
        if (exists('ccbhmessagebox-div')) {
            removeMsg();
            return;
        }
    } else {
        if (exists('ccbhmessagebox-div') && (overlay || recursive)) {
            backupIDs();
        } else {
            removeMsg();
        }
    }

    //modal, draw div that takes up entire screen
    if (modal) {
        var modaldiv = create('div');
        modaldiv.id = 'ccbhmessagebox-modaldiv';
        modaldiv.className = 'ccbhmessagebox-modaldiv ccbhmessagebox-opacity';
        modaldiv.style.width = '100%';
        document.body.appendChild(modaldiv);
    }
    //draw div box
    var div = create('div');
    div.onsize = function () { centerMessagebox(); };
    div.id = 'ccbhmessagebox-div';
    div.className = 'ccbhmessagebox-div';
    if (addmessageboxclass) {
        div.className += ' ' + addmessageboxclass;
    }

    var titlediv = create('div');
    titlediv.className = 'ccbhmessagebox-titlediv';
    if (notitlediv) {
        titlediv.style.display = 'none';
    }

    var table = create('table');
    table.className = 'ccbhmessagebox-titletable';
    var tr = table.insertRow();
    var td = tr.insertCell();
    td.className = 'ccbhmessagebox-titlecell';
    td.id = 'ccbhmessagebox-titlecell';
    if (title != undefined) {
        td.innerText = title;
    }

    if (closebutton) {
        var td = tr.insertCell();
        td.className = 'ccbhmessagebox-closebuttoncell';
        td.id = 'ccbhmessagebox-closebuttoncell';
        var closediv = create('div');
        closediv.className = 'ccbhmessagebox-closebuttondiv';
        closediv.innerText = 'x';
        closediv.onclick = removeMsg;
        td.appendChild(closediv);
    }
    titlediv.appendChild(table);
    div.appendChild(titlediv);

    if (message != undefined) {
        var messagediv = create('div');
        messagediv.id = 'ccbhmessagebox-messagediv';
        messagediv.className = 'ccbhmessagebox-messagediv';
        messagediv.innerHTML = message;
        div.appendChild(messagediv);
    }

    if (displaydiv != undefined) {
        displaydiv = get(displaydiv);
        if (displaydiv != undefined) {
            displaydiv.style.display = 'none';
            var msgboxdisplaydiv = create('div');
            msgboxdisplaydiv.id = 'ccbhmessagebox-displaydiv';
            msgboxdisplaydiv.className = 'ccbhmessagebox-displaydiv';
            msgboxdisplaydiv.innerHTML = displaydiv.innerHTML;
            div.setAttribute('displaydivid', displaydiv.id);
            div.appendChild(msgboxdisplaydiv);
            displaydiv.parentNode.removeChild(displaydiv);
        } else {
            if (alertNotFound) {
                alert('Display div not found');
            }
        }
    }

    if (clicktoclose) {
        if (document.addEventListener) {
            document.addEventListener('click', checkMsgClick, false);
        } else if (document.attachEvent) {
            document.attachEvent('onclick', checkIEMsgClick);
        }
    }

    if (buttons != undefined) {
        var buttonwrapper = create('div');
        buttonwrapper.className = 'ccbhmessagebox-buttonwrapper';

        var buttondiv = create('div');
        buttondiv.id = 'ccbhmessagebox-buttondiv';
        buttondiv.className = 'ccbhmessagebox-buttondiv';

        for (var i in buttons) {
            if (!buttons.hasOwnProperty(i)) continue;
            var button = create('div');
            button.className = 'ccbhmessagebox-button';
            button.id = 'ccbhmessagebox-button-' + makeCSSClass(i);
            button.innerText = i;
            if (buttons[i] != '') {
                button.onclick = buttons[i];
                //button.onclick += removeMsg;
            } else {
                button.onclick = removeMsg;
            }
            buttondiv.appendChild(button);
        }
        buttonwrapper.appendChild(buttondiv);
        div.appendChild(buttonwrapper);
    }

    if (width != undefined) {
        if (width.indexOf('%') != -1 || width.indexOf('px') != -1) {
            div.style.width = width;
        } else {
            div.style.width = width + 'px';
        }
    }
    if (height != undefined) {
        if (height.indexOf('%') != -1 || height.indexOf('px') != -1) {
            div.style.height = height;
        } else {
            div.style.height = height + 'px';
        }
    }
    document.body.appendChild(div);
    centerMessagebox();
    addEventHandler(window, 'resize', centerMessagebox);
    addEventHandler(div, 'resize', centerMessagebox);
}
function backupIDs() {
    get('ccbhmessagebox-modaldiv').id = 'ccbhmessagebox-modaldiv2';
    var msgboxdiv = get('ccbhmessagebox-div');
    msgboxdiv.id = 'ccbhmessagebox-div2';
    msgboxdiv.style.display = 'none';
    get('ccbhmessagebox-displaydiv').id = 'ccbhmessagebox-displaydiv2';

}
function restoreIDs() {
    get('ccbhmessagebox-modaldiv2').id = 'ccbhmessagebox-modaldiv';
    var msgboxdiv = get('ccbhmessagebox-div2')
    msgboxdiv.id = 'ccbhmessagebox-div';
    msgboxdiv.style.display = '';
    get('ccbhmessagebox-displaydiv2').id = 'ccbhmessagebox-displaydiv';
}
function makeCSSClass(text) {
    return text.replace(" ", "_").toLowerCase();
}
export function centerMessagebox() {
    var div = get('ccbhmessagebox-div');
    if (div != undefined && div != null) {
        var windowHeight = getWindowHeight();
        var windowWidth = getWindowWidth();
        div.style.top = (windowHeight / 2) - (div.clientHeight / 2) - 5 + 'px';
        div.style.left = (windowWidth / 2) - (div.clientWidth / 2) + 'px';
    }
}
//events for non-ie8 browsers - checks to see if the target is inside the messagebox or a single div inside it
function checkMsgClick(e) {
    if (e.target.className.indexOf('ccbhmessagebox') == -1) {
        var target = e.target.parentNode;
        if (target.className == undefined || target.className.indexOf('ccbhmessagebox') == -1) {
            removeMsg();
        }
    }
}
//event for ie8 and below - checks to see if the target is inside the messagebox or a single div inside it
function checkIEMsgClick(evt) {
    if (evt.srcElement.className.indexOf('ccbhmessagebox') == -1) {
        var target = evt.srcElement.parentNode;
        if (target.className == undefined || target.className.indexOf('ccbhmessagebox') == -1) {
            removeMsg();
        }
    }
}
//check to see if dtp is currently being displayed (prevents two from being shown)
function exists(elementName) {
    if (get(elementName) == undefined) {
        return false;
    } else {
        return true;
    }
}
//remove messagebox, see if it currently exists and removes html
export function removeMsg() {
    if (exists('ccbhmessagebox-div')) {
        var msg = get('ccbhmessagebox-div');
        //check if display div is being used
        if (exists('ccbhmessagebox-displaydiv')) {
            var displaydiv = get('ccbhmessagebox-displaydiv');
            displaydiv.style.display = 'none';
            displaydiv.id = msg.getAttribute('displaydivid');
            document.body.parentNode.appendChild(displaydiv);
            //get('main_content').appendChild(displaydiv);
        }
        msg.parentNode.removeChild(msg);
    }
    if (exists('ccbhmessagebox-modaldiv')) {
        var div = get('ccbhmessagebox-modaldiv');
        div.parentNode.removeChild(div);
    }
}
/**************TAB CONTROL****************/
function ccbhtabcontrol(params) {
    var tabs;
    tabs = loadParameter(params.tabs);
    //changed check for tabs to removing of tabs that don't exist
    tabs = checkExist(tabs);
    for (var i in tabs) {
        var tabdiv = get(tabs[i]);
        addToWrapper(i, tabdiv);
    }

    /*select first tab*/
    var tabdiv = get(tabs[0] + '_header');
    if (tabdiv != undefined) {
        selectTab(tabdiv);
    }
}

function checkExist(tabs) {
	var new_tabs = new Array();

    for (var i in tabs) {
    	if (get(tabs[i]) !== undefined && get(tabs[i]) !== null) {            
    		new_tabs.push(tabs[i]);
    	}
    }

    return new_tabs;
}


function selectTab(tab) {
    disableTabs();
    tab.className += ' ccbhtabcontrol-header-selected';
    var div = get(tab.getAttribute('target_id'));
    div.style.display = 'block';
    div.style.marginLeft = '10px';
    div.style.marginRight = '10px';
}
function disableTabs() {
    var wrapper = get('ccbhtabcontrol-headerwrapper');
    var headers = wrapper.childNodes;
    for (var i = 0; i < headers.length; i++) {
        removeCSS(headers[i], ' ccbhtabcontrol-header-selected');
        var div = get(headers[i].getAttribute('target_id'));
        div.style.display = 'none';
    }
}
function addToWrapper(index, div) {
		//if first element, create wrapper
		if (index == 0) {
			//wrap with div
			var wrapper = create('div');
			wrapper.id = 'ccbhtabcontrol-div';
			var headerWrapper = create('div');
			headerWrapper.id = 'ccbhtabcontrol-headerwrapper';
			wrapper.appendChild(headerWrapper);
			wrap(wrapper, div);
		} else {
			//else add to wrapper
			var wrapper = get('ccbhtabcontrol-div');
			wrapper.appendChild(div);
		}
		//add to header
		var headerWrapper = get('ccbhtabcontrol-headerwrapper');
		var header = create('div');
		header.className = 'ccbhtabcontrol-header';
		var title = div.getAttribute('title');
		if (title == undefined) {
			header.innerHTML = 'Untitled';
		} else {
			header.innerHTML = div.getAttribute('title');
		}
		var tabCSS = div.getAttribute('tabclass');
		if (tabCSS != undefined) {
			header.className += ' ' + tabCSS;
		}
		header.onclick = function () { selectTab(this); };
		header.setAttribute('target_id', div.id);
		header.id = div.id + '_header';
		if (index == 0) {
			header.className += ' ccbhtabcontrol-headerfirst';
		}
		headerWrapper.appendChild(header);
}




export function ccbhalert(parameters) {
    var message, displaydiv, title, closebutton, clicktoclose, buttons, modal, height, width, toggle;
    title = loadParameter(parameters.title);
    message = loadParameter(parameters.message);
    displaydiv = loadParameter(parameters.displaydiv);
    closebutton = loadParameter(parameters.closebutton);
    clicktoclose = loadParameter(parameters.clicktoclose);
    buttons = loadParameter(parameters.buttons);
    modal = loadParameter(parameters.modal);
    height = loadParameter(parameters.height);
    width = loadParameter(parameters.width);
    toggle = loadParameter(parameters.toggle);
    const overlay = loadParameter(parameters.overlay);
    const notitlediv = loadParameter(parameters.notitlediv);
    const addmessageboxclass = loadParameter(parameters.addmessageboxclass);

    if (buttons === undefined && closebutton === undefined) {
        closebutton = true;
    }
    if (toggle !== undefined && (toggle === true || toggle === 'true')) {
        if (exists('ccbhalert-div')) {
            removeAlert();
            return;
        }
    } else {
        if (exists('ccbhalert-div') && overlay) {
            alertbackupIDs();
        } else {
            removeAlert();
        }
    }

    //modal, draw div that takes up entire screen
    if (modal) {
        var modaldiv = create('div');
        modaldiv.id = 'ccbhalert-modaldiv';
        modaldiv.className = 'ccbhmessagebox-modaldiv ccbhmessagebox-opacity';
        modaldiv.style.width = '100%';
        document.body.appendChild(modaldiv);
    }
    //draw div box
    var div = create('div');
    div.onsize = function () { centerMessagebox(); };
    div.id = 'ccbhalert-div';
    div.className = 'ccbhmessagebox-div';
    if (addmessageboxclass) {
        div.className += ' ' + addmessageboxclass;
    }

    var titlediv = create('div');
    titlediv.className = 'ccbhmessagebox-titlediv';
    if (notitlediv) {
        titlediv.style.display = 'none';
    }

    var table = create('table');
    table.className = 'ccbhmessagebox-titletable';
    var tr = table.insertRow();
    var td = tr.insertCell();
    td.className = 'ccbhmessagebox-titlecell';
    td.id = 'ccbhalert-titlecell';
    if (title != undefined) {
        td.innerText = title;
    }

    if (closebutton) {
        var td = tr.insertCell();
        td.className = 'ccbhmessagebox-closebuttoncell';
        td.id = 'ccbhalert-closebuttoncell';
        var closediv = create('div');
        closediv.className = 'ccbhmessagebox-closebuttondiv';
        closediv.innerText = 'x';
        closediv.onclick = removeMsg;
        td.appendChild(closediv);
    }
    titlediv.appendChild(table);
    div.appendChild(titlediv);

    if (message !== undefined) {
        var messagediv = create('div');
        messagediv.id = 'ccbhalert-messagediv';
        messagediv.className = 'ccbhmessagebox-messagediv';
        messagediv.innerHTML = message;
        div.appendChild(messagediv);
    }

    if (displaydiv !== undefined) {
        displaydiv = get(displaydiv);
        if (displaydiv !== undefined) {
            displaydiv.style.display = 'none';
            var msgboxdisplaydiv = create('div');
            msgboxdisplaydiv.id = 'ccbhalert-displaydiv';
            msgboxdisplaydiv.className = 'ccbhmessagebox-displaydiv';
            msgboxdisplaydiv.innerHTML = displaydiv.innerHTML;
            div.setAttribute('displaydivid', displaydiv.id);
            div.appendChild(msgboxdisplaydiv);
            displaydiv.parentNode.removeChild(displaydiv);
        } else {
            if (alertNotFound) {
                alert('Display div not found');
            }
        }
    }

    if (clicktoclose) {
        if (document.addEventListener) {
            document.addEventListener('click', checkMsgClick, false);
        } else if (document.attachEvent) {
            document.attachEvent('onclick', checkIEMsgClick);
        }
    }

    if (buttons !== undefined) {
        var buttonwrapper = create('div');
        buttonwrapper.className = 'ccbhmessagebox-buttonwrapper';

        var buttondiv = create('div');
        buttondiv.id = 'ccbhalert-buttondiv';
        buttondiv.className = 'ccbhmessagebox-buttondiv';

        for (var i in buttons) {
            if (!buttons.hasOwnProperty(i)) continue;
            var button = create('div');
            button.className = 'ccbhmessagebox-button';
            button.id = 'ccbhalert-button-' + makeCSSClass(i);
            button.innerText = i;
            if (buttons[i] !== '') {
                button.onclick = buttons[i];
                //button.onclick += removeMsg;
            } else {
                button.onclick = removeMsg;
            }
            buttondiv.appendChild(button);
        }
        buttonwrapper.appendChild(buttondiv);
        div.appendChild(buttonwrapper);
    }

    if (width !== undefined) {
        if (width.indexOf('%') !== -1 || width.indexOf('px') !== -1) {
            div.style.width = width;
        } else {
            div.style.width = width + 'px';
        }
    }
    if (height !== undefined) {
        if (height.indexOf('%') !== -1 || height.indexOf('px') !== -1) {
            div.style.height = height;
        } else {
            div.style.height = height + 'px';
        }
    }
    document.body.appendChild(div);
    alertcenterMessagebox();
    addEventHandler(window, 'resize', centerMessagebox);
    addEventHandler(div, 'resize', centerMessagebox);
}
function alertbackupIDs() {
    get('ccbhalert-modaldiv').id = 'ccbhalert-modaldiv2';
    var msgboxdiv = get('ccbhalert-div');
    msgboxdiv.id = 'ccbhalert-div2';
    msgboxdiv.style.display = 'none';
    get('ccbhalert-displaydiv').id = 'ccbhalert-displaydiv2';

}
function alertrestoreIDs() {
    get('ccbhalert-modaldiv2').id = 'ccbhalert-modaldiv';
    var msgboxdiv = get('ccbhalert-div2')
    msgboxdiv.id = 'ccbhalert-div';
    msgboxdiv.style.display = '';
    get('ccbhalert-displaydiv2').id = 'ccbhalert-displaydiv';
}
function alertmakeCSSClass(text) {
    return text.replace(" ", "_").toLowerCase();
}
function alertcenterMessagebox() {
    var div = get('ccbhalert-div');
    if (div != undefined && div != null) {
        var windowHeight = getWindowHeight();
        var windowWidth = getWindowWidth();
        div.style.top = (windowHeight / 2) - (div.clientHeight / 2) - 5 + 'px';
        div.style.left = (windowWidth / 2) - (div.clientWidth / 2) + 'px';
    }
}
//events for non-ie8 browsers - checks to see if the target is inside the messagebox or a single div inside it
function alertcheckMsgClick(e) {
    if (e.target.className.indexOf('ccbhalert') == -1) {
        var target = e.target.parentNode;
        if (target.className == undefined || target.className.indexOf('ccbhalert') == -1) {
            removeAlert();
        }
    }
}
//event for ie8 and below - checks to see if the target is inside the messagebox or a single div inside it
function alertcheckIEMsgClick(evt) {
    if (evt.srcElement.className.indexOf('ccbhalert') === -1) {
        var target = evt.srcElement.parentNode;
        if (target.className === undefined || target.className.indexOf('ccbhmessagebox') === -1) {
            removeAlert();
        }
    }
}

//remove messagebox, see if it currently exists and removes html
export function removeAlert() {
    if (exists('ccbhalert-div')) {
        var msg = get('ccbhalert-div');
        //check if display div is being used
        if (exists('ccbhalert-displaydiv')) {
            var displaydiv = get('ccbhalert-displaydiv');
            displaydiv.style.display = 'none';
            displaydiv.id = msg.getAttribute('displaydivid');
            document.body.parentNode.appendChild(displaydiv);
            //get('main_content').appendChild(displaydiv);
        }
        msg.parentNode.removeChild(msg);
    }
    if (exists('ccbhalert-modaldiv')) {
        var div = get('ccbhalert-modaldiv');
        div.parentNode.removeChild(div);
    }
}